import React from 'react';
import type { ListItemTextProps } from '@mui/material';
import { ListItemText as MuiListItemText } from '@mui/material';

type Props = ListItemTextProps;

const ListItemText: React.FC<Props> = ({ primaryTypographyProps, ...props }) => (
    <MuiListItemText
        primaryTypographyProps={{ color: 'textPrimary', ...primaryTypographyProps }}
        {...props}
    />
);

export default ListItemText;
